module.exports = __webpack_public_path__ + "static/media/typing_speed_test.4574a615.gif";